import { createApiWithToken } from "services/config/api.config";
import { ApiConstant } from "const";
import StringFormat from "string-format";

export const getModule = () => createApiWithToken().get(ApiConstant.MODULE);

export const getRolePermission = data => createApiWithToken().get(StringFormat(ApiConstant.PERMISSION, data));
